export default {
  USER: 0,
  SUPER_ADMIN: 10,
  SUPPORT_ADMIN: 20,
  ADMINISTRATOR: 30,
  DRUG_ADMIN: 40,
};
